import { render, staticRenderFns } from "./AccordionBox.vue?vue&type=template&id=3f87a8d5&scoped=true&"
import script from "./AccordionBox.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AccordionBox.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AccordionBox.vue?vue&type=style&index=0&id=3f87a8d5&prod&lang=scss&"
import style1 from "./AccordionBox.vue?vue&type=style&index=1&id=3f87a8d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87a8d5",
  null
  
)

export default component.exports